<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="0"
    transition="scale-transition"
    offset-y
    min-width="250px"
    :disabled="disabled"
  >
    <template v-slot:activator="{ on, attrs }">
      <validation-provider v-slot="{ errors }" :rules="rules">
        <v-text-field
          v-model="formatedMonth"
          :error-messages="errors"
          v-mask="'##/####'"
          :label="label"
          :dense="dense"
          :hide-details="hideDetails"
          :append-icon="appendIcon"
          v-bind="attrs"
          v-on="on"
          @blur="month = parseMonth(formatedMonth)"
          :style="maxWidth ? `max-width: ${maxWidth}` : undefined"
          class="pt-0"
          :clearable="clearable"
          :outlined="outlined"
          :filled="filled"
          :solo="solo"
          :disabled="disabled"
        />
      </validation-provider>
    </template>
    <v-date-picker
      type="month"
      :min="minMonth"
      :max="maxMonth"
      v-model="month"
      @input="
        menu = false;
        formatedMonth = formatMonth(month);
      "
      :landscape="false"
      locale="pt-br"
    />
  </v-menu>
</template>

<script>
  import dayjs from "dayjs";

  export default {
    name: "InputMonth",
    props: {
      label: {
        type: String,
        default: null,
      },
      rules: {
        type: String,
        default: "min:7",
      },
      selectedMonth: {
        type: String,
        default: null,
      },
      minMonth: {
        type: String,
        default: "",
      },
      maxMonth: {
        type: String,
        default: "",
      },
      clearable: {
        type: Boolean,
        default: true,
      },
      outlined: {
        type: Boolean,
        default: true,
      },
      dense: {
        type: Boolean,
        default: true,
      },
      filled: {
        type: Boolean,
        default: false,
      },
      solo: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      hideDetails: {
        type: [Boolean, String],
        default: "auto",
      },
      appendIcon: {
        type: String,
        default: "mdi-calendar-blank",
      },
      maxWidth: {
        type: String,
        default: "11rem",
      },
    },
    data() {
      return {
        month: null,
        formatedMonth: null,
        menu: false,
      };
    },
    mounted() {
      if (this.selectedMonth) {
        this.month = this.selectedMonth;
        this.formatedMonth = this.formatMonth(this.selectedMonth);
      }
    },
    watch: {
      month() {
        this.$emit("monthSelected", this.month);
      },
      selectedMonth() {
        if (this.selectedMonth) {
          this.month = this.selectedMonth;
          this.formatedMonth = this.formatMonth(this.selectedMonth);
        } else {
          this.month = null;
          this.formatedMonth = null;
        }
      },
    },
    methods: {
      parseMonth(date) {
        if (!date) return null;
        const [month, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}`;
      },
      formatMonth(date) {
        if (date.length > 10) {
          date = date.substr(0, 10);
        }
        return dayjs(date).format("MM/YYYY");
      },
    },
  };
</script>
